import styled from 'styled-components';
import Label from '../../../_shared/components/Label';

export const CarouselContainer = styled.section`
  grid-area: carousel;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ isLightbox }) => (isLightbox ? 'max-height: 100vh' : '')};
  ${({ isLightbox }) => (isLightbox ? 'width: calc(55vw - 80px)' : '')};
`;

export const ThumbnailsContainer = styled.div`
  overflow-x: hidden;
  margin: 0 auto;
`;

export const CarouselThumbnails = styled.ul`
  width: inherit;
  display: flex;
  white-space: nowrap;
  position: relative;

  /* This calculates how much to shift the carousel thumbnails to the left */
  left: calc(
    (
        -1 * (100% / ${({ numberInCarousel }) => numberInCarousel}) * ${({ multiple }) => multiple}
      ) - 12px
  );

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    display: none;
  }
`;

export const CarouselItem = styled.li`
  position: relative;
  flex: 0 0 calc((100% / ${({ numberInCarousel }) => numberInCarousel}) - 12px);
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:last-child {
    margin-right: 0;
  }
`;

export const CarouselMain = styled.div`
  position: relative;
  width: ${({ isLightbox }) => (isLightbox ? 'calc(55vw - 80px)' : '100%')};
  margin: 0 auto;
  max-height: ${({ isLightbox }) => (isLightbox ? '75vh' : '100%')};
  margin-bottom: 11px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    height: initial;
  }
`;

export const CarouselMainPhoto = styled.img`
  object-fit: contain;
  display: block;
  width: 100%;
  height: auto;
  max-height: inherit;
`;

export const CarouselMainVideo = styled.video`
  object-fit: contain;
  display: block;
  width: 100%;
  height: auto;
  max-height: inherit;
`;

const CarouselNav = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  width: 44px;
  height: 44px;

  &:hover {
    background: rgba(255, 255, 255, 0.7);
  }

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    width: 30px;
    height: 30px;
  }

  svg {
    position: absolute;
    width: 24px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media only screen and (max-width: ${({ theme }) =>
        theme.BP.VDP_MOBILE_WH}) {
      width: 18px;
    }
  }
`;

export const StyledCarouselPrev = styled(CarouselNav)`
  left: 24px;
`;

export const StyledCarouselNext = styled(CarouselNav)`
  right: 24px;
`;

export const CarouselCounter = styled.div`
  display: inline-block;
  min-width: 60px;
  width: max-content;
  background: rgba(0, 0, 0, 0.75);
  color: ${({ theme }) => theme.COLORS.BASE};
  border-radius: 6px;
  padding: 4px 16px;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
`;

export const PhotoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.COLORS.BASE};
  opacity: 0.7;
  cursor: pointer;
`;

export const CarouselPhoto = styled.img`
  width: 100%;
  cursor: pointer;
`;

export const CarouselVideo = styled.video`
  width: 100%;
  cursor: pointer;
`;

export const LabelContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 74px;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 12.5%,
    rgba(0, 0, 0, 0.7) 67.19%
  );
`;

export const StyledCarouselLabel = styled(Label)`
  position: absolute;
  top: 18px;
  left: 18px;
  color: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
    line-height: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
    top: 18px;
    left: 18px;
  }
`;
